// library imports
import * as Constants from "_core/configs/Constants";
import dataManagerInstance from "_core/managers/DataManager";
import { getTime } from "_core/utils/common";

/**
 * テンプレートファイルダウンロード API
 * バイナリレスポンスを受け取りそのままファイル保存するため、
 * 共通 ApiRequest (JSON前提) は使用せず fetch を直接使用する。
 */
const AdminDownloadTemplateApi = () => {
    const url = "/admin/download_template";

    /**
     * @param {string} file_type      - ダウンロードするテンプレートの種別識別子 (例: "INQUIRY_FORMAT")
     * @param {string} fallbackFilename - Content-Disposition が取得できなかった場合のファイル名
     */
    const ExecAdminDownloadTemplateApi = async ({ file_type, fallbackFilename = "template.txt" }) => {
        try {
            const nowTime = getTime();

            const params = new URLSearchParams();
            params.append("file_type", file_type);
            params.append("api_timestamp", nowTime);
            params.append("is_editor", true);

            const response = await fetch(Constants.BASE_URL + url, {
                mode: "cors",
                method: "POST",
                credentials: "include",
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: params.toString(),
            });

            if (!response.ok) {
                throw new Error(`Download failed: ${response.status}`);
            }

            const contentType = response.headers.get("content-type");
            if (contentType?.includes("application/json")) {
                const responseJson = await response.json();
                if (responseJson.error_code && responseJson.error_code > 0) {
                    return { error: responseJson.error_detail }
                }
            }

            // Content-Disposition ヘッダーからファイル名を取得
            // RFC 5987 形式 (filename*=UTF-8''...) を優先し、fallback で通常の filename="" を使用
            const disposition = response.headers.get("Content-Disposition") || "";
            const rfc5987Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            const plainMatch = disposition.match(/filename="(.+?)"/i);
            const filename = rfc5987Match
                ? decodeURIComponent(rfc5987Match[1])
                : plainMatch
                ? plainMatch[1]
                : fallbackFilename;

            // Blob に変換してブラウザダウンロードをトリガー
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(objectUrl);

            return { error: null };
        } catch (e) {
            const result = {
                "code": 900000,
                "title": "エラー",
                "message": Constants.UNKNOWN_ERROR_DETAIL, 
                "event": 0,
                "value": ""
            }
            return { error: result };
        }
    };

    return ExecAdminDownloadTemplateApi;
};

export default AdminDownloadTemplateApi;
